import { ActionReducerMapBuilder, createSlice } from '@reduxjs/toolkit';

import { getLocationMenuSectionsThunk } from './thunks';

import { IPagination } from '@ready/dashboardv2api.contracts';
import { IBulkEditMenuSection } from '@ready/menu.core';

interface State {
  items: IBulkEditMenuSection[];
  pagination?: IPagination;
  loading: boolean;
}

const initialState: State = {
  loading: true,
  items: [],
};

export const sectionLocationSettingsSlice = createSlice({
  name: 'sharedMenus/menus/locationSettings',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder: ActionReducerMapBuilder<State>) => {
    builder.addCase(getLocationMenuSectionsThunk.pending, (state: State) => {
      state.loading = true;
    });
    builder.addCase(getLocationMenuSectionsThunk.fulfilled, (state: State, action) => {
      state.loading = false;
      const { items, ...pagination } = action.payload;
      state.items = items;
      state.pagination = pagination;
    });

    builder.addCase(getLocationMenuSectionsThunk.rejected, (state: State) => {
      state.loading = false;
    });
  },
});
